export default __webpack_public_path__ + "static/media/Lunches-hover.4f9b9f11.svg";